const BRANCH_OFFICE = [
  {
    name: "宝達志水町",
    postal: "",
    address: "宝達志水町",
    lat: 36.82827,
    lng: 136.80025
  }
];

export { BRANCH_OFFICE };
